module.exports = __webpack_public_path__ + "img/wall-e.4d5c13df.png";